module.exports = __webpack_public_path__ + "img/banner-10.fb88ea4f.jpg";